export default {"src":"/newStatic/_next/static/media/pattern-3.63417887.svg","height":30,"width":768};